import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

interface LogoProps {
  className?: string;
  variant?: "default" | "condensed";
}

export function Logo({ className, variant = "default" }: LogoProps) {
  return (
    <Link to="/" className={cn("flex items-center no-underline", className)}>
      <div className="mr-2 rounded-md bg-primary p-1 flex items-center justify-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="h-6 w-6 text-white"
        >
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
          <path d="M22 7l-10 5L2 7" />
        </svg>
      </div>
      {variant === "default" && (
        <div className="text-xl font-semibold text-foreground animate-fade-in">
          Formcraft
        </div>
      )}
    </Link>
  );
}
